import { create } from 'zustand';
import WhoamiResponse = App.Data.Response.WhoamiResponse;

interface UseWhoamiStore extends WhoamiResponse {
	loggedIn: undefined | boolean;
	hasResolvedWhoami: boolean;
	setWhoami: (whoami: WhoamiResponse) => void;
	setWeGlotLanguageCode: (weGlotLanguageCode: string) => void;
}

export const useWhoamiStore = create<UseWhoamiStore>(
	set =>
		({
			loggedIn: undefined,
			hasResolvedWhoami: false,
			setWhoami: whoami =>
				set({
					loggedIn: !!whoami.user,
					hasResolvedWhoami: true,
					...whoami,
				}),
			setWeGlotLanguageCode: weGlotLanguageCode =>
				set({
					weGlotLanguageCode,
				}),
		}) as UseWhoamiStore,
);
